/** Route of the rulebook page („Regelwerke“) for platform-role holders. */
export const RULEBOOK_PATH = "/rulebook";
